import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "./useAuth";
import * as XLSX from "xlsx";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Pagination from "./Pagination";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "./Manage_User.css";
import "./Loader.css";
import { FaFilePdf,FaFileExcel } from "react-icons/fa";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Loader = () => (
  <div className="loader-container1">
    <div className="spinner1"></div>
    <p>Loading...</p>
  </div>
);

const ManageAuditCheckCMZMConveyance = () => {
  useAuth();
  const navigate = useNavigate();

  const [EmpCode, setEmpCode] = useState("");
  const [items, setItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showLogPopup, setShowLogPopup] = useState(false);
    const [logResponse, setLogResponse] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // ✅ Fetch profile first
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const res = await fetch(`${API_BASE_URL}profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await res.json();
        if (result.status && result.profile?.emp_code) {
          setEmpCode(result.profile.emp_code);
        }
      } catch (err) {
        console.error("Profile fetch error:", err);
      }
    };
    fetchProfile();
  }, []);

  // ✅ Fetch conveyance data AFTER EmpCode is ready
  useEffect(() => {
    const fetchItems = async () => {
      if (!EmpCode) return;
      setLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(`${API_BASE_URL}getauditmasterdetails`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await res.json();

        if (result.status && result.data) {
          // Wrap single object in array
          setItems(result.data);
          setError("");
        } else {
          setItems([]);
          setError("No records found");
        }
      } catch (err) {
        console.error("Fetch conveyance error:", err);
        setItems([]);
        setError("Failed to fetch conveyance details");
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [EmpCode]);

  // ✅ Filter items
  const filteredItems = items.filter((item) => {
    const q = searchQuery.toLowerCase();
    return (
      item.comp_name?.toLowerCase().includes(q) ||
      item.emp_code?.toLowerCase().includes(q) ||
      item.role?.toLowerCase().includes(q) ||
      item.month_year?.toLowerCase().includes(q) ||
      item.conveyance_status?.toLowerCase().includes(q) ||
      item.total_visit_amount?.toLowerCase().includes(q) ||
      item.audit_status?.toLowerCase().includes(q) ||
      item.finance_status?.toLowerCase().includes(q)
    );
  });

  // ✅ Pagination logic
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const startItem = filteredItems.length === 0 ? 0 : indexOfFirstItem + 1;
  const endItem = Math.min(indexOfLastItem, filteredItems.length);

  // ✅ Export to Excel
  const exportToExcel = () => {
    const data = filteredItems.map((item) => ({
      EmpCode: item.emp_code,
      Employee: item.comp_name,
      // Role: item.role,
      // ConveyanceStatus: item.conveyance_status,
      // Month: item.month_year,
      // total_visit_amount: item.total_visit_amount,
      audit_status: item.audit_status,
      finance_status: item.account_status,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Conveyance");
    XLSX.writeFile(wb, "CM_ZM_Conveyance.xlsx");
  };

  const formatDate = (d) => {
    if (!d) return "";
    const date = new Date(d);
    return date.toLocaleDateString("en-GB");
  };

  const downloadPDF = async (detailId) => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await fetch(
        `${API_BASE_URL}getmyvisitdetails/${detailId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const result = await res.json();

      if (!result.status || !result.data.length) {
        alert("No data found");
        return;
      }

      const rows = result.data;

      const doc = new jsPDF("p", "mm", "a4");

      /* ================= HEADER ================= */
      doc.setFontSize(14);
      doc.text("ZM / CM Conveyance Punch Details", 14, 15);

      doc.setFontSize(10);
      doc.text(`Details ID : ${rows[0].details_id}`, 14, 25);
      doc.text(`Generated On : ${new Date().toLocaleDateString("en-GB")}`, 14, 31);

      /* ================= TABLE ================= */
      doc.autoTable({
        startY: 40,
        head: [[
          "S.No",
          "Date",
          "Branch",
          "From Time",
          "To Time",
          "Duration",
          "Remarks",
          "Entry Type"
        ]],
        body: rows.map((r, i) => [
          i + 1,
          r.Punch_date,
          r.Branch,
          r.From_Time?.substring(0, 5) || "-",
          r.To_Time?.substring(0, 5) || "-",
          r.Duration || "-",
          r.Remarks || "-",
          r.EntryType || "-"
        ]),
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [52, 152, 219],
          textColor: 255,
        },
      });

      doc.save(`Conveyance_${detailId}.pdf`);
    } catch (err) {
      console.error(err);
      alert("PDF download failed");
    }
  };

  const downloadExcel = async (detailId) => {
  try {
    const token = localStorage.getItem("authToken");

    const res = await fetch(
      `${API_BASE_URL}getmyvisitdetails/${detailId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const result = await res.json();

    if (!result.status || !result.data.length) {
      alert("No data found");
      return;
    }

    const rows = result.data;

    // 🔹 Prepare Excel rows
    const excelData = rows.map((r, index) => ({
      "S.No": index + 1,
      "Date": r.Punch_date,
      "Branch": r.Branch,
      "From Time": r.From_Time?.substring(0, 5) || "",
      "To Time": r.To_Time?.substring(0, 5) || "",
      "Duration": r.Duration || "",
      "Remarks": r.Remarks || "",
      "Entry Type": r.EntryType || "",
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Conveyance Details");

    XLSX.writeFile(wb, `Conveyance_${detailId}.xlsx`);
  } catch (err) {
    console.error(err);
    alert("Excel download failed");
  }
};

const handleLog = async (id, month) => {
    try {
      const token = localStorage.getItem('authToken');

      const response = await fetch(`${API_BASE_URL}fixed_conveyance_log_form/${id}/${month}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const result = await response.json();

      // Save API response
      setLogResponse(result);
      setShowLogPopup(true);

    } catch (error) {
      console.error("Error fetching log:", error);
      setLogResponse({ message: "Something went wrong!" });
      setShowLogPopup(true);
    }
  };
  const formatTime = (t) => {
    if (!t || t === "0" || t === "00:00:00") return null;
    return t.substring(0, 5);
  };


  return (
    <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
      <div className="wrapper">
        <Header />
        <Sidebar />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h4 className="m-0" style={{ fontSize: '20px' }}>
                    Fixed Conveyance - Audit
                  </h4>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">(CM / ZM) Conveyance </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="card">
                <div className="card-header">
                  {/* <h4 style={{ float: "left" }}>Tour / Travel – Local Conveyance</h4> */}
                  <div style={{ float: "right" }}>
                    {/* <Link to="/add_checklocalzmcmconveyance">
                      <button className="btn btn-success mr-2">Add New</button>
                    </Link> */}
                    <button className="btn btn-secondary" onClick={exportToExcel}>
                      Export
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <div style={{ float: "right", marginBottom: "10px" }}>
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>

                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Emp Code</th>
                              <th>Comp Name</th>
                              <th>Month</th>
                              <th>Audit Status</th>

                              {/* <th>Emp Status</th> */}

                              <th>Finance Status</th>

                              {/* <th>Attachment</th> */}
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length > 0 ? (
                              currentItems.map((item, index) => (
                                <tr key={item.id || index}>
                                  <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                  <td>{item.emp_code}</td>
                                  <td>{item.comp_name}</td>
                                  <td>{item.month}</td>

                                  <td>
                                    <span
                                      style={{
                                        padding: "4px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        color: "#fff",
                                        backgroundColor:
                                          item.audit_status === "Pending"
                                            ? "#f59e0b"
                                            : item.audit_status === "Approved"
                                              ? "#16a34a"
                                              : item.audit_status === "Rejected"
                                                ? "#dc2626"
                                                : "#6b7280",
                                      }}
                                    >
                                      {item.audit_status}
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      style={{
                                        padding: "4px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        color: "#fff",
                                        backgroundColor:
                                          item.account_status === "Pending"
                                            ? "#f59e0b"
                                            : item.account_status === "Approved"
                                              ? "#16a34a"
                                              : item.account_status === "Rejected"
                                                ? "#dc2626"
                                                : "#6b7280",
                                      }}
                                    >
                                      {item.account_status}
                                    </span>
                                  </td>



                                  <td>
                                    <Link to={`/edit_auditcheckcmzm_conveyance/${item.id}/${item.month}`}>
                                      <button
                                        className="btn btn-sm btn-primary"
                                        style={{ fontSize: "11px", padding: "3px 8px" }}
                                      >
                                        Edit
                                      </button>
                                    </Link>
                                    <button
                                      onClick={() => downloadPDF(item.id)}
                                      title="Download PDF"
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: "4px",
                                      }}
                                    >
                                      <FaFilePdf
                                        size={18}
                                        color="#d32f2f"
                                        style={{ verticalAlign: "middle" }}
                                      />
                                    </button>
                                     <button
    onClick={() => downloadExcel(item.id)}
    title="Download Excel"
    style={{
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: "4px",
    }}
  >
    <FaFileExcel size={18} color="#16a34a" />
  </button>
  {item.audit_status === 'Approved' && (<i
                                      className="fa fa-eye"
                                      onClick={() => handleLog(item.id, item.month)}
                                      style={{ fontSize: '12px', color: 'green', cursor: 'pointer' }}
                                    ></i>)}

                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="11" align="center">
                                  {error || "No records found"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={setCurrentPage}
              />

              <div className="mb-3">
                Showing {startItem} to {endItem} of {filteredItems.length} entries
              </div>
            </div>
          </section>
        </div>
        {showLogPopup && logResponse?.data && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                width: "85%",
                maxHeight: "85vh",
                overflowY: "auto",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              {/* HEADER */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h4>Conveyance Logs</h4>
                <button
                  onClick={() => setShowLogPopup(false)}
                  className="btn btn-sm btn-danger"
                >
                  ✕
                </button>
              </div>

              {/* EMPLOYEE DETAILS */}
              <div style={{ marginBottom: "15px", fontSize: "13px" }}>
                <b>Employee:</b> {logResponse.data.form?.comp_name || "-"} <br />
                <b>Emp Code:</b> {logResponse.data.form?.emp_code || "-"} <br />
                <b>Month:</b> {logResponse.data.form?.month || "-"}
              </div>

              {/* LOG TABLE */}
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Branch</th>

                    <th>User From</th>
                    <th>User To</th>

                    <th>Audit From</th>
                    <th>Audit To</th>

                    <th>Duration</th>
                    <th>Audit Status</th>
                    <th>Audit Remarks</th>
                  </tr>
                </thead>

                <tbody>
                  {logResponse.data.details?.length > 0 ? (
                    logResponse.data.details.map((log, i) => (
                      <tr key={i}>
                        <td>{log.Punch_date}</td>
                        <td>{log.Branch}</td>

                        {/* USER FROM (fallback to audit) */}
                        <td style={{ color: "#2563eb", fontWeight: 600 }}>
                          {formatTime(log.From_Time_user) ||
                            formatTime(log.From_Time) ||
                            "-"}
                        </td>

                        {/* USER TO (fallback to audit) */}
                        <td style={{ color: "#2563eb", fontWeight: 600 }}>
                          {formatTime(log.To_Time_user) ||
                            formatTime(log.To_Time) ||
                            "-"}
                        </td>

                        {/* AUDIT FROM */}
                        <td style={{ color: "#16a34a", fontWeight: 600 }}>
                          {formatTime(log.From_Time) || "-"}
                        </td>

                        {/* AUDIT TO */}
                        <td style={{ color: "#16a34a", fontWeight: 600 }}>
                          {formatTime(log.To_Time) || "-"}
                        </td>

                        <td>{log.Duration || "-"}</td>
                        <td>{logResponse.data.form?.audit_status || "-"}</td>
                        <td>{logResponse.data.form?.audit_remarks || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" align="center">
                        No logs found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default ManageAuditCheckCMZMConveyance;
